import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SecureYourSlot() {
  return <section data-section-id="136737" id="immediate-relief" className="dark bg-background text-foreground px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden border-none bg-secondary bg-gradient-to-br from-secondary to-primary/10 p-[40px] shadow-2xl rounded-2xl">
          {}
          <div className="absolute inset-0 bg-secondary/60 backdrop-blur-sm"></div>

          <div className="relative z-10 grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-8">
            <div className="text-center md:text-left">
              <h2 className="font-sans text-4xl font-bold tracking-tight uppercase text-white sm:text-5xl lg:text-6xl">
                Ready to wake up refreshed?
              </h2>
            </div>

            <div className="flex flex-col items-center justify-center gap-6 sm:flex-row md:justify-end">
              <Link to="tel:+13108587373" className="flex items-center gap-3 text-2xl font-semibold tracking-wide text-white transition-colors hover:text-white/80 md:text-3xl">
                <Phone className="h-6 w-6 md:h-8 md:w-8" />
                Call Now
              </Link>
              <Button size="lg" className="h-14 px-8 text-lg font-semibold uppercase tracking-wide bg-chart-2 hover:bg-chart-2/90 text-white rounded-full shadow-lg transition-all" asChild>
                <Link to="#">Book Consultation</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}